require('./RAAccordionWizard.scss');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

class RAAccordionWizard extends React.Component {
    constructor(props) {
        super(props);

        this.handlePrevClick = this.handlePrevClick.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        this.handleFinishClick = this.handleFinishClick.bind(this);
        this.handleEditClick = this.handleEditClick.bind(this);
    }

    handlePrevClick() {
        const { visibleStep } = this.props;
        this.props.resetStep(visibleStep);
        this.props.setVisibleStep(visibleStep - 1);
    }

    handleNextClick() {
        this.props.validateStep(this.props.visibleStep, this.props.history);
    }

    handleFinishClick() {
        this.props.finish(this.props.history);
    }

    handleEditClick(selectedStep) {
        this.props.immSteps.forEach((immStep, index) => {
            if (index > selectedStep) {
                this.props.resetStep(index);
            }
        });

        this.props.setVisibleStep(selectedStep);
    }

    buildSteps() {
        const steps = React.Children.map(
            this.props.children,
            (child, index) => {
                if (child === null) {
                    return;
                }
                const active = this.props.visibleStep === index;
                const valid = this.props.immSteps.getIn([index, 'valid']);
                const errorFlags = this.props.immSteps.getIn([
                    index,
                    'errorFlags',
                ]);
                const additionalProps = {
                    active,
                    disabled: !valid && !active,
                    onEditClick: this.handleEditClick,
                    onPrevClick: this.handlePrevClick,
                    onNextClick: this.handleNextClick,
                    onFinishClick: this.handleFinishClick,
                    step: index,
                    valid,
                    errorFlags,
                };

                return React.cloneElement(child, additionalProps);
            },
        );

        return steps;
    }

    render() {
        const steps = this.buildSteps();

        return (
            <div className="ra-accordion-wizard">
                <div
                    id="printable-wizard"
                    className="ra-accordion-wizard__content"
                >
                    {steps}
                </div>
            </div>
        );
    }
}

RAAccordionWizard.propTypes = {
    children: PropTypes.any.isRequired,
    history: PropTypes.object.isRequired,
    immSteps: PropTypes.object.isRequired,
    finish: PropTypes.func.isRequired,
    resetStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    visibleStep: PropTypes.number.isRequired,
};

module.exports = withRouter(RAAccordionWizard);
